import { render, staticRenderFns } from "./collectList.vue?vue&type=template&id=024706e8&scoped=true&"
import script from "./collectList.vue?vue&type=script&lang=js&"
export * from "./collectList.vue?vue&type=script&lang=js&"
import style0 from "./collectList.vue?vue&type=style&index=0&id=024706e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024706e8",
  null
  
)

export default component.exports